import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TLabelChat } from '../types/label-chat.type';

/**
 *
 */
export const createLabelChatValidationSchema = z.object({
  name: z.string().min(1),
  color: z.string().min(1),
});

export type TCreateLabelChatValidation = z.infer<typeof createLabelChatValidationSchema>;
export type TCreateLabelChatPayload = TCreateLabelChatValidation;
export type TCreateLabelChatResponse = ApiResponse<TLabelChat>;

export const createLabelChat = async (data: TCreateLabelChatPayload): Promise<TCreateLabelChatResponse> => {
  const url = '/label-chat';

  return axiosInstance.post(url, data);
};

/**
 * Use Create Label Chat React-Query Hook
 */
type TUseCreateLabelChatMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof createLabelChat, AxiosErrorCustom>;
};

export const useCreateLabelChatMutation = ({ mutationConfigOptions }: TUseCreateLabelChatMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};

  return useMutation({
    mutationFn: createLabelChat,
    ...restConfigOptions,
  });
};
